import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import './i18n';
import { SerialPortProvider } from './context/SerialPortContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <AuthProvider>
     <SerialPortProvider>
    <App />
    </SerialPortProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
